/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'address': {
    width: 16,
    height: 16,
    viewBox: '0 0 12 16',
    data: '<path pid="0" class="st0" d="M6 0C2.7 0 0 2.7 0 6c0 2.2 2 5.5 6 10 4-4.5 6-7.8 6-10 0-3.3-2.7-6-6-6zm0 10c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/views/icons/address.js